import { FILTER_STEPS } from "@/constants/filters-constants";
import { createSlice } from "@reduxjs/toolkit";

// 1. "filters" array removed - it now lives in component useState
export const initialTableState = {
  step: FILTER_STEPS.SELECT_FIELD,
  selectedField: null,
  selectedOperator: null,
  fieldValue: "",
  editingIndex: null,
};

// Helper to ensure tableId key exists before modifying
const ensureTableState = (state, tableId) => {
  if (!state[tableId]) {
    state[tableId] = { ...initialTableState };
  }
};

export const tableFilterSlice = createSlice({
  name: "tableFilter",
  initialState: {},
  reducers: {
    // Modified to be self-initializing
    setStep: (state, action) => {
      const { tableId, step } = action.payload;
      ensureTableState(state, tableId);
      state[tableId].step = step;
    },

    setSelection: (state, action) => {
      const { tableId, field, operator, value } = action.payload;
      ensureTableState(state, tableId);
      const table = state[tableId];

      if (field !== undefined) table.selectedField = field;
      if (operator !== undefined) table.selectedOperator = operator;
      if (value !== undefined) table.fieldValue = value;
    },

    // Now accepts the 'filter' object from the component state
    openEditFilter: (state, action) => {
      const { tableId, index, filter } = action.payload;
      ensureTableState(state, tableId);

      state[tableId].editingIndex = index;
      state[tableId].selectedField = {
        accessor: filter.fieldName,
        label: filter.fieldLabel,
        dataType: filter.dataType,
      };
      state[tableId].selectedOperator = {
        value: filter.searchOperator,
        label: filter.operatorLabel,
      };
      state[tableId].fieldValue = filter.fieldValue;
      state[tableId].step = FILTER_STEPS.ENTER_VALUE;
    },

    // Purely resets the UI form state
    resetForm: (state, action) => {
      const tableId = action.payload;
      state[tableId] = { ...initialTableState };
    },
  },
});

// Removed: saveFilter, removeFilter, clearFilters, initTable (handled by ensureTableState)
export const { setStep, setSelection, openEditFilter, resetForm } =
  tableFilterSlice.actions;

export default tableFilterSlice.reducer;
